import { buildMeetingsBucketDemoRow, emptyMeetingLoadBucket, generateMeetingsBucketMockRaw, sharePercent } from '@web/lib/demo/utils/meetingsBucketDemoUtils';
import { emptyMeetingsBackToBackRawCounts, MEETINGS_BACK_TO_BACK_KEYS } from '@workalizer/shared';
import { randomInt } from '@workalizer/shared/utils';
export var meetingsBackToBackAnalytic = function (input) {
    var includeTeamMetrics = input.userId == null;
    var current = emptyMeetingsBackToBackRawCounts();
    var previous = emptyMeetingsBackToBackRawCounts();
    for (var _i = 0, MEETINGS_BACK_TO_BACK_KEYS_1 = MEETINGS_BACK_TO_BACK_KEYS; _i < MEETINGS_BACK_TO_BACK_KEYS_1.length; _i++) {
        var key = MEETINGS_BACK_TO_BACK_KEYS_1[_i];
        current[key] = generateMeetingsBucketMockRaw();
        previous[key] = generateMeetingsBucketMockRaw();
    }
    var currentBucketTotal = MEETINGS_BACK_TO_BACK_KEYS.reduce(function (sum, key) { return sum + current[key].meetingCount; }, 0);
    var previousBucketTotal = MEETINGS_BACK_TO_BACK_KEYS.reduce(function (sum, key) { return sum + previous[key].meetingCount; }, 0);
    var currentTotal = currentBucketTotal + randomInt(20, 60);
    var previousTotal = previousBucketTotal + randomInt(20, 60);
    return {
        rows: MEETINGS_BACK_TO_BACK_KEYS.map(function (key) {
            var _a, _b;
            var curr = (_a = current[key]) !== null && _a !== void 0 ? _a : emptyMeetingLoadBucket();
            var prev = (_b = previous[key]) !== null && _b !== void 0 ? _b : emptyMeetingLoadBucket();
            return buildMeetingsBucketDemoRow(key, curr, prev, sharePercent(curr.meetingCount, currentTotal), sharePercent(prev.meetingCount, previousTotal), includeTeamMetrics);
        })
    };
};
